import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { sizes } from "../../../constants/spacing";
/**
 * @deprecated please use @smartsheet/sds-toast-state-service instead. See
 * https://static.smart.ninja/storybook/team-ui-engineering/lodestar-core/mainline/sds-toast-ui/storybook/index.html
 */
export var ToastActions = styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: inline-flex;\n    align-items: center;\n    margin: ", "px ", "px 0 0;\n"])), sizes.xSmall, sizes.xSmall);
//# sourceMappingURL=ToastActions.js.map